// extracted by mini-css-extract-plugin
export default {"root":"RowActions_root__cmTBk","action":"RowActions_action__CdsIQ","icon":"RowActions_icon__1pMFv","iconBtn":"RowActions_iconBtn__k3Gfr","danger":"RowActions_danger__pskdD"};